var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#303641;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.24,1.75a6,6,0,1,1-8.48,0A6,6,0,0,1,10.24,1.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.46,8.12,3.88,9.53,6,7.41,8.12,9.53,9.54,8.12,7.41,6,9.54,3.88,8.12,2.46,6,4.58,3.88,2.46,2.46,3.88,4.59,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossOn);
export default __webpack_public_path__ + "static/media/cross_on.6a5d799ff7f89e6b42fdf56e4885b02c.svg";
export { ForwardRef as ReactComponent };